module.exports = __webpack_public_path__ + "static/media/bg4.9b0351c1.png";